// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"b010c863","85":"b88e495e","185":"8fcfaef7","545":"f00211a0","845":"526afc8f"}[chunkId] + ".chunk.js";
};